export function useStatConverters() {
  const doubleToPercentage = (value) => {
    return (value * 100).toFixed(0) + '%';
  }
  const percentageToColor = (value) => {
    if (value > 0.6) {
      return 'success';
    }
    if (value < 0.3) {
      return 'error';
    }
    return 'grey';
  }

  return {
    doubleToPercentage,
    percentageToColor
  };
}

